import React, { useEffect } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import AuthLoader from './components/common/AuthLoader'

const Login = () => {
  const { loginWithRedirect, isLoading } = useAuth0()
  useEffect(() => {
    if (!isLoading) {
      loginWithRedirect()
    }
  }, [isLoading, loginWithRedirect])
  return <AuthLoader />
}
export default Login
